import React, { ComponentType, SVGProps } from 'react';
import c from 'classnames';
import { getSvgByName, IconName } from './getSvgByName';
import styles from './Icon.module.css';

type IconSizes = 'xs' | 's' | 'm' | 'l' | 'xl' | number;

type BaseIconProps = {
  responsive?: boolean;
  className?: string;
  size?: IconSizes;
  active?: boolean;
  preserveColors?: boolean;
};

type IconWithNameProps = BaseIconProps & {
  name: IconName;
  Svg?: never; // Disallow Svg when name is provided
};

type IconWithSvgProps = BaseIconProps & {
  Svg: ComponentType<SVGProps<SVGSVGElement>>;
  name?: never; // Disallow name when Svg is provided
};

type IconProps = IconWithNameProps | IconWithSvgProps;

export const Icon = ({
  name,
  Svg: CustomSvg,
  responsive,
  className = '',
  size = 'm',
  active = false,
  preserveColors = false,
}: IconProps) => {
  // If name is provided, get the SVG from the lookup
  // Otherwise, use the provided custom SVG
  const SvgComponent = name ? getSvgByName(name) : CustomSvg;

  if (!SvgComponent) {
    console.error('Icon: Either name or Svg must be provided');
    return null;
  }

  return (
    <span className={c(className, styles.icon)}>
      <SvgComponent
        className={c(
          active && styles.active,
          !preserveColors && styles.iconSvg,
          typeof size !== 'number' ? styles[size] : null,
          responsive && styles.responsive,
        )}
        style={{
          height: typeof size === 'number' ? `${size}px` : undefined,
          width: typeof size === 'number' ? `${size}px` : undefined,
        }}
        data-testid={name ? `icon-${name}` : 'custom-icon'}
        role='img'
      />
    </span>
  );
};
